var exports = {
  "k": "xa15a2ab7--551ffd--container",
};

module.exports = exports;
